// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 270) return "js/fullcalendar-" + __webpack_require__.h() + ".js";
	// return url for filenames based on template
	return "js/" + "vendor" + "-" + "dce29e0b54524d181667" + ".js";
};